<template>
  <div class="auditLog">
    <div v-if="openLog === 2">
      <div class="no-userContact-btn">
        当前未启用审计日志服务。<i @click="openLogPage">去开启</i>
      </div>
    </div>
    <div v-if="openLog === 3">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="登录/登出日志" name="first">
          <div class="btns">
            <el-form ref="searchInfo" :inline="true" :model="searchInfo">
              <el-form-item label="" prop="user">
                <el-input
                  v-model.trim="searchInfo.user"
                  placeholder="操作人"
                ></el-input>
              </el-form-item>
              <el-form-item label="" prop="types">
                <el-select
                  v-model="searchInfo.types"
                  placeholder="请选择事件类型"
                  clearable
                  size="small"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.name"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" prop="dateFrom">
                <el-date-picker
                  v-model="searchInfo.dateFrom"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="起始时间"
                  :picker-options="pickerOptionsStart"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="" prop="dateTo">
                <el-date-picker
                  v-model="searchInfo.dateTo"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="结束时间"
                  :picker-options="pickerOptionsEnd"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchList(false)"
                  >查询</el-button
                >
              </el-form-item>
              <el-form-item>
                <el-button @click="searchList(true)">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table
            :data="tableData"
            tooltip-effect="light"
            style="width: 100%"
          >
            <el-table-column
              label="时间"
              prop="time"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              label="事件类型"
              prop="type"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.row.type === "LOGIN"
                    ? "登录成功"
                    : scope.row.type === "LOGIN_ERROR"
                    ? "登录失败"
                    : scope.row.type === "LOGOUT"
                    ? "登出成功"
                    : "登出失败"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作人"
              prop="user"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              label="IP地址"
              prop="ipAddress"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              label="客户端"
              prop="client"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, prev, pager, next"
            :page-size="pageSize"
            :current-page.sync="pageNum"
            :total="total"
            @current-change="pageChange"
          >
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import APIS from "@/apis/auditLog.js"
import APISYSTEM from "@/apis/systemSetting.js"
import { Message } from "element-ui"
export default {
  data() {
    return {
      moduleTitle: "审计日志",
      dialogRemoveOrAnable: false,
      openLog: 1,
      // 开始起始点禁用日期筛选
      pickerOptionsStart: {
        disabledDate: (time) => {
          return this.dealDisabledDateStart(time)
        }
      },
      // 开始结束点禁用日期筛选
      pickerOptionsEnd: {
        disabledDate: (time) => {
          return this.dealDisabledDateEnd(time)
        }
      },
      searchInfo: {
        user: null,
        types: null,
        dateFrom: null,
        dateTo: null,
      },
      activeName: "first",
      tableData: [],
      breadcrumb: [
        {
          label: "审计日志"
        }
      ],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      realmName: this.$realm,
      currentClientId: "",
      options: [
        { name: "登录成功", value: "LOGIN" },
        { name: "登录失败", value: "LOGIN_ERROR" },
        { name: "登出成功", value: "LOGOUT" },
        { name: "登出失败", value: "LOGOUT_ERROR" }
      ]
    }
  },
  mounted() {
    this.getAuditState()
  },
  methods: {
    // 查询审计状态
    async getAuditState() {
      let { status, data } = await APISYSTEM.getAuditState(this.$realm)
      if (status === 0) {
        data ? ((this.openLog = 3), this.getLogsList()) : (this.openLog = 2)
      }
    },
    // 前往打开审计日志
    openLogPage() {
      this.$router.push({
        path: "settings",
        query: {
          activeName: "second"
        }
      })
    },
    // 查询日志列表
    async getLogsList() {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        user: this.searchInfo.user ? this.searchInfo.user : null,
        types: this.searchInfo.types ? this.searchInfo.types : null,
        dateFrom : this.searchInfo.dateFrom,
        dateTo : this.searchInfo.dateTo
      }
      if (!(this.searchInfo.dateFrom === null && this.searchInfo.dateTo === null) && !(this.searchInfo.dateFrom && this.searchInfo.dateTo)) {
         Message.info({
          message: !this.searchInfo.dateFrom ? '请选择起始时间' : '请选择结束时间'
        })
        return false
      }
      let { data } = await APIS.getLogList(this.realmName, {
        params
      })
      this.total = 0
      this.tableData = []
      if (data) {
        this.total = data.totalCount
        for (var i in data.data) {
          this.tableData.push(data.data[i])
          this.tableData[i].time = this.getDate(data.data[i].time)
        }
      }
    },
    // 开始时间不能晚于结束时间
    dealDisabledDateStart(time) {
      if (!this.searchInfo.dateTo) {
        return false
      }
      let times = new Date(this.searchInfo.dateTo).getTime()

      return times < new Date(time).getTime()
    },
    // 截止时间不能早于开始时间
    dealDisabledDateEnd(time) {
      if (!this.searchInfo.dateFrom) {
        return false
      }
      let times = new Date(this.searchInfo.dateFrom).getTime()

      return times > new Date(time).getTime()
    },
    // 翻页
    pageChange() {
      this.getLogsList()
    },
    // 查询
    searchList(type) {
      if (type) {
        //重置
        this.$refs["searchInfo"].resetFields()
      }
      this.pageNum = 1
      this.getLogsList()
    },
    getDate(time) {
      let d = new Date(time)
      let year = d.getFullYear()
      let month = d.getMonth() + 1
      month = month < 10 ? "0" + month : month
      let date = d.getDate() < 10 ? "0" + d.getDate() : d.getDate()
      let hour = d.getHours() < 10 ? "0" + d.getHours() : d.getHours()
      let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes()
      let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds()
      return (
        year + "-" + month + "-" + date + " " + hour + ":" + min + ":" + sec
      )
    },
    // 切换标签页
    handleClick() {}
  }
}
</script>

<style lang="scss">
.auditLog {
  .no-userContact-btn {
    position: absolute;
    top: 50%;
    font-weight: 500;
    font-size: 16px;
    left: 50%;
    margin: -100px 0 0 -100px;
    i {
      border-bottom: 1px solid #4497ec;
      font-style: normal;
      color: #4497ec;
      cursor: pointer;
    }
  }
  .btns {
    margin: 0 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-form {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    }
  }
  .el-select .el-tag__close.el-icon-close {
    background-color: #999;
    right: -7px;
    top: 0;
    color: #fff;
    height: 16px;
    width: 16px;
  }
}
</style>
<style scoped>
</style>